import React from "react"
import { useSelector } from "react-redux";
import { selectAgentRep, selectCountryList199 } from "../../selectors";
import { initalizeActorValues } from "../../util/constants";

const isAllFieldsEmpty=(rest)=>Object.entries(rest).every(c=>c[1]?.trim())
export const useValidateNameAddressUsingEori=(isImportShipment,isDMS,actorType)=>{
    const {id,contact,eoriNo,addressLine2,state,...rest} = useSelector((state) => state.Actor[actorType])
    const rep=useSelector(selectAgentRep)
    const Eori=useSelector((state)=>state.Actor[actorType=="declarant" ? "agent":"declarant"].eoriNo)
    const countryList=useSelector(selectCountryList199)
    const isExporterExistInEUCountries=React.useMemo(()=>{
        if((isDMS || isImportShipment) && actorType!="exporter" ) return false // skip validation if  actor type <> exporter
        if(actorType=="exporter")
           return countryList?.some(c=>c.value==rest.country && c.type=="EU")
        
    },[countryList,rest.country,actorType,isDMS,isImportShipment])
   return React.useMemo(()=>{
        const response={name:rest.name}
         if(isDMS || isImportShipment ) return response
         
         if(rep==1){
            
             if(actorType=="declarant" && !isAllFieldsEmpty({...initalizeActorValues,eoriNo:eoriNo,...rest})){
              response.validationMsg=`If value of Representational Status is 1 then ${actorType} is required.`
              return response
             }
             else if (actorType=="agent"){
                 response.disableFields={name:true,eoriNo:true,addressLine1:true,addressLine2:true,city:true,state:true,postalCode:true,country:true}
                 return response
             }
         }

         else if(rep==2){
             if((actorType=="agent" || actorType=="declarant") && eoriNo?.trim()!=Eori?.trim() && eoriNo?.trim() && Eori?.trim() && !isAllFieldsEmpty({...initalizeActorValues,...rest})){
                response.validationMsg=`If value of Representational Status is ${rep} and Eori No. is not equal to ${actorType=="declarant" ? "agent":"declarant"} EoriNo. then ${actorType} is required.`
                return response
             }
         }
         else if(rep==3){
            if((actorType=="agent" || actorType=="declarant") && eoriNo?.trim()==Eori?.trim() && eoriNo?.trim() && Eori?.trim() && !isAllFieldsEmpty({...initalizeActorValues,...rest})){
               response.validationMsg=`If value of Representational Status is ${rep} and Eori No. is equal to ${actorType=="declarant" ? "agent":"declarant"} EoriNo. then ${actorType} is required.`
               return response
            }
        }

        if(actorType=="exporter" && rep && isExporterExistInEUCountries && !isAllFieldsEmpty({...initalizeActorValues,eoriNo:eoriNo,...rest})){
            response.validationMsg="Selected country is within EU , exporter details are mandatory."
            return response
        }
         
             if(!eoriNo?.trim()){
                let {state,...initalizeActorValuesUpdated} = initalizeActorValues
                if(!isAllFieldsEmpty({...initalizeActorValuesUpdated,...rest}))
                    response.validationMsg="If Eori No. is empty then name and address cannot be empty"
             }
          
         
         return response
},[isImportShipment,isDMS,eoriNo,Eori,rep,rest,isExporterExistInEUCountries])
}